require('lessRoot/auto-parts.less');

Blain.AutoParts = {

	init() {
		this.initForm();
		this.initQuestionModal();
		this.initPartsList();
	},

	initForm() {

		const $form = $('.ap-lookup-form');

		if (!$form.length) return;

		if ($form.hasClass('is-tire')) {
			this.initTireVehicleLookupModal();
			return;
		}

		const $yearSelect = $('select#vehicleYear');
		const $makeSelect = $('select#vehicleMake');
		const $modelSelect = $('select#vehicleModel');
		const $engineSelect = $('select#vehicleEngine');
		const $submitButton = $('#apSubmit');
		const $modal = $(".ap-vehicle-lookup-modal");
		const $closeModal = $modal.find(".close-modal");
		const $editButton = $(".ap-edit-vehicle");
		const isModal = !!$modal.length;
		let year, makeId, modelId, engineId, vehicles;

		function getResult(action, callback) {
			$.getJSON(`/auto-parts/a/${action}`, callback);
		}

		function getPostResult(action, data, success) {
			if (data) data = JSON.stringify(data);
			$.ajax({
				contentType: "application/json",
				dataType: "json",
				url: `/auto-parts/a/${action}`,
				method: 'POST',
				data: data,
				success
			});
		}

		function updateSelectList($list, options, valKey, label) {
			$list.empty();
			if (options.length === 1) {
				$list.append($(`<option value="" disabled>Select ${label}</option>`));
				$list.append($(`<option value="${options[0][valKey]}" selected>${options[0].Description}</option>`));
				$list.change();
			} else {
				$list.append($(`<option value="" selected disabled>Select ${label}</option>`));
				options.forEach(m => {
					$list.append($(`<option value="${m[valKey]}">${m.Description}</option>`));
				});
			}
			$list.prop('disabled', false);
		}

		function clearList($list) {
			const placeholder = $list.find('option').eq(0);
			$list.empty();
			$list.append(placeholder);
			$list.find('option').prop('selected', true);
		}

		function clearLists(lists) {
			lists.forEach(clearList);
		}

		function addYears(years) {
			years.forEach(year => {
				$yearSelect.append($(`<option value="${year}">${year}</option>`));
			});
		}

		function addMakes(makes) {
			updateSelectList($makeSelect, makes, 'MakeID', 'MAKE');
		}

		function addModels(models) {
			vehicles = models;
			$modelSelect.empty();
			$modelSelect.append($(`<option value="" selected disabled>Select MODEL</option>`));
			vehicles.forEach(v => {
				// The makeID might be different than the selected make if this vehicle is a truck.
				// The make id attached to each vehicle will be correct, so add each vehicle's make ID as
				// a data attribute. We will use it to update the makeID when this vehicle is selected
				$modelSelect.append($(`<option data-make-id="${v.MakeID}" value="${v.ModelID}">${v.Description}</option>`));
			});
			$modelSelect.prop('disabled', false);
		}

		function addEngines(engines) {
			updateSelectList($engineSelect, engines, 'EngineID', 'ENGINE');
		}

		function getYears() {
			// Don't get years again if we already have them
			if ($yearSelect.find('option').length > 1) return;
			getResult('getyears', addYears);
		}

		function getMakes() {
			getResult(`getmakes?year=${year}`, addMakes);
		}

		function getModels() {
			getResult(`getmodels?year=${year}&makeid=${makeId}`, addModels);
		}

		function getEngines() {
			const model = vehicles.find((x) => {
				return x.ModelID == modelId && x.MakeID == makeId;
			});
			getPostResult('getengines', model, addEngines);
		}

		function saveVehicle() {
			getResult(`savevehicle?year=${year}&makeid=${makeId}&modelId=${modelId}&engineId=${engineId}`, () => {
				if (isModal) window.location.reload();
				else window.location = '/auto-parts/categories';
			});
		}

		$form.off('submit').on('submit', function (e) {
			e.preventDefault();
			if (!year || !makeId || !modelId || !engineId) return;
			$.modalProgress('Please Wait...');
			saveVehicle();
		});

		$yearSelect.off('change').on('change', function () {
			clearLists([$makeSelect, $modelSelect, $engineSelect]);
			year = $yearSelect.val();
			if (parseInt(year) == 0) getYears();
			else getMakes();
		});

		$makeSelect.off('change').on('change', function () {
			clearLists([$modelSelect, $engineSelect]);
			makeId = $makeSelect.val();
			if (parseInt(makeId) == 0) getMakes();
			else getModels();
		});

		$modelSelect.off('change').on('change', function () {
			clearList($engineSelect);
			const $selectedOption = $modelSelect.find(":selected");
			if ($selectedOption.length) {
				const validMakeID = $selectedOption.data('make-id');
				if (validMakeID) makeId = validMakeID;
			}
			modelId = $modelSelect.val();
			getEngines();
		});

		$engineSelect.off('change').on('change', function () {
			engineId = $engineSelect.val();
			$submitButton.prop('disabled', false);
		});

		$editButton.off('click').on('click', function (e) {
			getYears();
			$modal.addClass('active');
		});

		if ($closeModal.length) {
			$closeModal.off('click').on('click', () => $modal.removeClass('active'));
		}
	},

	initPartsList() {
		if (!document.getElementById("autoPartsList")) return;

		function init(ajax = false) {
			if (ajax) Blain.Catalog.initSimpleSelect();
			initPagination();
			initPageSize();
		}

		function initPagination() {
			const $pagination = $(".ap-pagination a");
			if (!$pagination.length) return;
			$pagination.off('click').on('click', function (e) {
				e.preventDefault();
				const href = $(this).attr('href');
				if (!href || href.indexOf('?') === -1) return;
				paginate(href);
			});
		}

		function initPageSize() {
			const $select = $(".ap-pagination .simple-select");
			if (!$select.length) return;
			const $options = $select.find('.option');
			$options.on('simple:selected', function () {
				const queryString = $(this).data('qs');
				if (!queryString) return;
				$select.find('.header-text').text($(this).data('value'));
				paginate(queryString);
			});
		}

		function paginate(queryString) {
			const $modal = $.modalProgress("Please Wait");
			const path = window.location.pathname.split('auto-parts/')[1];
			const url = `/auto-parts/a/${path}${queryString}`;
			$.getJSON(url, function (res) {
				$modal.blainModal('hide');
				if (!res || !res.html) return;
				$("#autoPartsList").replaceWith(res.html);
				init(true);
			});
		}

		init();
	},

	initTireVehicleLookupModal() {

		const self = this;
		const $form = $('.ap-lookup-form.is-tire');

		if (!$form.length) return;

		const vehicleYear = $form.find("select#vehicleYear");
		const vehicleMake = $form.find("select#vehicleMake");
		const vehicleModel = $form.find("select#vehicleModel");
		const vehicleTrim = $form.find("select#vehicleTrim");
		const $editButton = $(".ap-edit-vehicle");
		const $modal = $(".ap-vehicle-lookup-modal");
		const $submitButton = $form.find("button");

		const car = {
			year: null,
			model: null,
			make: null,
			trim: null
		};

		function getQueryString() {
			return `?year=${car.year}&make=${car.make}&model=${car.model}&trim=${car.trim}`;
		}

		function updateCar() {
			car.year = vehicleYear.val();
			car.make = vehicleMake.val();
			car.model = vehicleModel.val();
			car.trim = vehicleTrim.val();
		};

		function get(url, callback) {
			$.ajax({
				type: "GET",
				url,
				dataType: "json",
				contentType: "application/json",
				error: (xhr) => {
					$.globalAjaxError(xhr.responseJSON);
				},
				success: callback
			});
		}

		function getCar(callback) {
			get(`/tires/a/vehicle${getQueryString()}`, (car) => {
				window.location = window.location;
			});
		}

		function getYears() {
			if (vehicleYear.find('option').length > 1) return;
			get(`/tires/a/vehicle/years${getQueryString()}`, (years) => {
				years.forEach(year => {
					const $option = $(`<option value="${year}">${year}</option>`);
					vehicleYear.append($option);
				});
			});
		}

		vehicleYear.off("change").on("change", function () {
			vehicleMake.val("");
			vehicleModel.val("");
			vehicleModel.prop("disabled", true);
			vehicleTrim.val("");
			vehicleTrim.prop("disabled", true);

			if (!vehicleYear.val()) {
				vehicleMake.prop("disabled", true);
				return;
			}
			updateCar();
			get(`/tires/a/vehicle/makes${getQueryString()}`, (makes) => {
				vehicleMake.html('<option value="" selected disabled>Select MAKE</option>');
				makes.forEach(make => {
					const $option = $(`<option value="${make}">${make}</option>`);
					vehicleMake.append($option);
				});
				vehicleMake.prop("disabled", false);
			});

		});


		vehicleMake.off("change").on("change", function () {
			vehicleTrim.prop("disabled", true);
			vehicleTrim.val("");
			vehicleModel.val("");
			if (!vehicleMake.val()) {
				vehicleModel.prop("disabled", true);
				return;
			}
			updateCar();
			get(`/tires/a/vehicle/models${getQueryString()}`, (models) => {
				vehicleModel.html('<option value="" selected disabled>Select MODEL</option>');
				models.forEach(model => {
					const $option = $(`<option value="${model}">${model}</option>`);
					vehicleModel.append($option);
					vehicleModel.prop("disabled", false);
				});
			});
		});

		vehicleModel.off("change").on("change", function () {
			if (!vehicleModel.val()) {
				vehicleTrim.val("");
				vehicleTrim.prop("disabled", true);
				return;
			}
			updateCar();
			get(`/tires/a/vehicle/trims${getQueryString()}`, (trims) => {
				vehicleTrim.html('<option value="" selected disabled>Select TRIM</option>');
				trims.forEach(trim => {
					const $option = $(`<option value="${trim}">${trim}</option>`);
					vehicleTrim.append($option);
					vehicleTrim.prop("disabled", false);
				});
			});
		});

		vehicleTrim.off("change").on("change", function() {
			updateCar();
		});

		$editButton.off('click').on('click', function (e) {
			getYears();
			$modal.addClass('active');
		});

		$submitButton.on('click', function(e) {
			e.preventDefault();
			if (!car.trim) return;
			getCar();
		});
	},

	initQuestionModal() {

		const $modal = $(".ap-question-modal");
		if (!$modal.length) return;

		const $questions = $('.ap-vehicle-question');
		const $list = $('#autoPartsList');
		const answers = {};

		function submitAnswers() {
			const questions = [];
			for (const key in answers) {
				if (!answers.hasOwnProperty(key) || answers[key] === null) continue;
				answers[key].forEach(x => questions.push(x));
			}
			$modal.hide();
			$.modalProgress("Please Wait");
			$.ajax({
				contentType: 'application/json; charset=utf-8',
				dataType: 'json',
				method: 'POST',
				url: `/auto-parts/a/answer`,
				data: JSON.stringify({ questions: questions }),
				success() {
					window.location.reload();
				}
			});
		}

		$questions.each(function () {
			const $t = $(this);
			const id = $t.data('ap-question').toString();
			const $select = $t.find('select');
			const changeVal = function () {
				const currentAnswer = JSON.parse($select.val());
				answers[id] = currentAnswer;
			};

			// Set the answer to the currently-selected value
			changeVal();

			// Also set the answer when the selection value changes
			$select.on('change', changeVal);
		});

		$modal.find('a.btn').on('click', submitAnswers);
	}

};

(function($) {
	$(document).ready(function() {
		Blain.AutoParts.init();
	});
})(jQuery);